var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _rect4, _path5, _path6, _rect5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _path7, _path8, _path9, _line10, _line11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElectric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 756,
    height: 378,
    viewBox: "0 0 756 378",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.7676,
    y: 156.455,
    width: 635.085,
    height: 85.056,
    rx: 11.3408,
    fill: "white",
    stroke: "black",
    strokeWidth: 11.3408
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M539.08 156.455V241.511",
    stroke: "black",
    strokeWidth: 11.3408,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.538 156.455V241.511",
    stroke: "black",
    strokeWidth: 11.3408,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 176.174,
    y: 241.512,
    width: 567.04,
    height: 102.067,
    rx: 5.6704,
    fill: "white",
    stroke: "black",
    strokeWidth: 11.3408
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M592.957 337.908H743.218C768.735 337.908 717.217 371.931 705.893 372.896C694.569 373.861 595.304 374.766 575.457 372.896C565.619 371.969 594.078 363.363 595.793 354.919C597.538 346.33 592.957 337.908 592.957 337.908Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M592.957 337.908V332.238H583.417L587.976 340.618L592.957 337.908ZM575.457 372.896L574.925 378.541L574.925 378.541L575.457 372.896ZM705.893 372.896L706.374 378.546L706.374 378.546L705.893 372.896ZM595.793 354.919L590.236 353.791L590.236 353.791L595.793 354.919ZM743.218 332.238H592.957V343.579H743.218V332.238ZM574.925 378.541C585.194 379.509 615.313 379.742 643.893 379.629C672.482 379.517 700.423 379.053 706.374 378.546L705.411 367.246C700.039 367.704 672.686 368.175 643.849 368.289C615.003 368.402 585.566 368.153 575.989 367.25L574.925 378.541ZM706.374 378.546C708.722 378.346 711.45 377.407 713.984 376.346C716.669 375.222 719.7 373.714 722.831 371.986C729.088 368.532 736.042 364.029 741.849 359.518C744.752 357.264 747.45 354.944 749.656 352.694C751.773 350.536 753.802 348.08 754.929 345.534C755.505 344.233 756.012 342.54 755.875 340.647C755.726 338.579 754.83 336.661 753.248 335.203C750.534 332.7 746.573 332.238 743.218 332.238V343.579C746.243 343.579 746.254 344.179 745.562 343.541C744.991 343.015 744.619 342.23 744.564 341.462C744.521 340.869 744.691 340.644 744.558 340.944C744.267 341.603 743.386 342.891 741.559 344.754C739.822 346.525 737.542 348.503 734.892 350.562C729.594 354.678 723.14 358.861 717.35 362.058C714.457 363.655 711.805 364.963 709.605 365.885C707.254 366.869 705.895 367.205 705.411 367.246L706.374 378.546ZM592.957 337.908C587.976 340.618 587.975 340.616 587.974 340.615C587.974 340.615 587.973 340.613 587.973 340.612C587.972 340.611 587.971 340.609 587.97 340.608C587.969 340.605 587.967 340.603 587.966 340.601C587.964 340.597 587.963 340.595 587.964 340.595C587.964 340.596 587.968 340.603 587.976 340.619C587.991 340.649 588.022 340.708 588.065 340.795C588.15 340.969 588.284 341.25 588.446 341.622C588.773 342.371 589.202 343.464 589.586 344.78C590.376 347.49 590.856 350.741 590.236 353.791L601.35 356.048C602.475 350.508 601.537 345.254 600.473 341.605C599.93 339.742 599.323 338.193 598.844 337.095C598.604 336.543 598.394 336.099 598.236 335.779C598.157 335.618 598.09 335.488 598.04 335.391C598.015 335.343 597.993 335.302 597.976 335.27C597.968 335.254 597.96 335.24 597.954 335.228C597.951 335.222 597.948 335.217 597.945 335.212C597.944 335.209 597.942 335.207 597.941 335.205C597.941 335.204 597.94 335.202 597.939 335.202C597.939 335.2 597.938 335.199 592.957 337.908ZM590.236 353.791C590.298 353.488 590.358 353.663 589.773 354.324C589.224 354.946 588.367 355.704 587.168 356.578C584.757 358.336 581.663 360.067 578.58 361.747C577.1 362.553 575.583 363.37 574.295 364.108C573.068 364.811 571.709 365.633 570.66 366.488C570.169 366.888 569.371 367.591 568.743 368.582C568.115 369.574 567.042 371.929 568.304 374.615C569.378 376.901 571.419 377.723 572.173 377.986C573.132 378.322 574.118 378.465 574.925 378.541L575.989 367.25C575.566 367.211 575.622 367.178 575.918 367.282C576.008 367.313 577.654 367.846 578.568 369.792C579.67 372.137 578.672 374.1 578.324 374.651C577.976 375.2 577.661 375.413 577.826 375.278C578.088 375.064 578.729 374.638 579.936 373.946C581.084 373.288 582.435 372.561 584.005 371.706C587.022 370.062 590.749 368.002 593.849 365.742C595.406 364.607 596.976 363.301 598.273 361.832C599.535 360.403 600.86 358.462 601.35 356.048L590.236 353.791Z",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 578.773,
    y: 133.772,
    width: 158.771,
    height: 22.6816,
    rx: 5.6704,
    fill: "black",
    stroke: "black",
    strokeWidth: 11.3408
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.7334,
    y: 235.842,
    width: 578.381,
    height: 113.408,
    rx: 11.3408,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8416 337.908H255.56H344.725H584.443C609.96 337.908 578.773 371.931 567.449 372.896C558.87 373.627 384.281 373.25 300.142 373.025C216.004 373.25 41.415 373.627 32.8361 372.896C21.5123 371.931 -9.67487 337.908 15.8416 337.908Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M567.449 372.896L566.967 367.246L566.967 367.246L567.449 372.896ZM300.142 373.025L300.158 367.354L300.142 367.354L300.127 367.354L300.142 373.025ZM32.8361 372.896L33.3177 367.246L33.3177 367.246L32.8361 372.896ZM255.56 332.238H15.8416V343.579H255.56V332.238ZM255.56 343.579H344.725V332.238H255.56V343.579ZM344.725 343.579H584.443V332.238H344.725V343.579ZM584.443 343.579C587.118 343.579 588.266 344.044 588.605 344.245C588.729 344.319 588.682 344.319 588.605 344.203C588.529 344.09 588.528 344.022 588.539 344.092C588.576 344.333 588.573 345.142 587.979 346.672C587.41 348.137 586.447 349.881 585.112 351.794C582.438 355.624 578.655 359.583 574.907 362.61C573.041 364.117 571.282 365.313 569.774 366.13C568.17 367 567.249 367.222 566.967 367.246L567.93 378.546C570.479 378.328 573.01 377.276 575.179 376.1C577.444 374.872 579.781 373.252 582.032 371.433C586.519 367.81 591.061 363.083 594.41 358.286C596.086 355.886 597.559 353.332 598.551 350.776C599.518 348.285 600.202 345.35 599.751 342.386C599.257 339.138 597.455 336.315 594.402 334.499C591.607 332.836 588.147 332.238 584.443 332.238V343.579ZM566.967 367.246C565.126 367.403 552.973 367.521 533.876 367.586C514.998 367.65 489.75 367.664 462.134 367.649C406.903 367.618 342.226 367.467 300.158 367.354L300.127 378.695C342.197 378.808 406.884 378.958 462.127 378.989C489.748 379.005 515.014 378.991 533.914 378.927C552.594 378.863 565.482 378.754 567.93 378.546L566.967 367.246ZM32.3545 378.546C34.8025 378.754 47.6909 378.863 66.3708 378.927C85.271 378.991 110.537 379.005 138.158 378.989C193.401 378.958 258.087 378.808 300.158 378.695L300.127 367.354C258.059 367.467 193.382 367.618 138.151 367.649C110.535 367.664 85.2866 367.65 66.4092 367.586C47.3115 367.521 35.1591 367.403 33.3177 367.246L32.3545 378.546ZM15.8416 332.238C12.1375 332.238 8.67788 332.836 5.88248 334.499C2.82936 336.315 1.02807 339.138 0.533926 342.386C0.0830471 345.35 0.76654 348.285 1.73368 350.776C2.72602 353.332 4.19855 355.886 5.87443 358.286C9.22338 363.083 13.7657 367.81 18.2526 371.433C20.5043 373.252 22.8405 374.872 25.1059 376.1C27.2748 377.276 29.8057 378.328 32.3545 378.546L33.3177 367.246C33.0356 367.222 32.1148 367 30.5104 366.13C29.0025 365.313 27.2437 364.117 25.3779 362.61C21.6298 359.583 17.8468 355.624 15.1731 351.794C13.8376 349.881 12.8744 348.137 12.3057 346.672C11.7119 345.142 11.7091 344.333 11.7457 344.092C11.7564 344.022 11.7556 344.09 11.6801 344.203C11.6029 344.319 11.5558 344.319 11.6803 344.245C12.0191 344.044 13.1666 343.579 15.8416 343.579V332.238Z",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.0766,
    y: 133.772,
    width: 555.699,
    height: 22.6816,
    rx: 5.6704,
    fill: "white",
    stroke: "black",
    strokeWidth: 11.3408
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 605.417,
    y1: 247.182,
    x2: 605.417,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 625.264,
    y1: 247.182,
    x2: 625.264,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 645.111,
    y1: 247.182,
    x2: 645.111,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 664.957,
    y1: 247.182,
    x2: 664.957,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 684.803,
    y1: 247.182,
    x2: 684.803,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 704.65,
    y1: 247.182,
    x2: 704.65,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 724.496,
    y1: 247.182,
    x2: 724.496,
    y2: 343.578,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 539.08,
    y1: 215.995,
    x2: 697.851,
    y2: 215.995,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 539.08,
    y1: 181.971,
    x2: 697.851,
    y2: 181.971,
    stroke: "black",
    strokeWidth: 5.6704
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M652.819 357.755C653.865 355.024 656.439 337.908 663.68 337.908C670.92 337.908 673.979 355.8 674.541 357.755C675.102 359.71 673.98 366.26 670.92 366.26H655.937C653.319 366.26 651.773 360.485 652.819 357.755Z",
    fill: "black",
    stroke: "white",
    strokeWidth: 5.6704,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M400.155 128.103L278.241 6.18945",
    stroke: "black",
    strokeWidth: 11.3408,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M468.2 128.103L346.286 6.18945",
    stroke: "black",
    strokeWidth: 11.3408,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 567.433,
    y1: 130.938,
    x2: 584.444,
    y2: 130.938,
    stroke: "black",
    strokeWidth: 5.6704
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 567.433,
    y1: 159.29,
    x2: 584.444,
    y2: 159.29,
    stroke: "black",
    strokeWidth: 5.6704
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectric);
export default __webpack_public_path__ + "static/media/electric.e5e74393b34e9e29d35f04337469d65f.svg";
export { ForwardRef as ReactComponent };